import { CartAddEvent } from '@theme/events';

/**
 * "You may also like" with quick add.
 * Loads the recommendations section, then handles the Add buttons: adds one item through the
 * AJAX cart, refreshes the basket drawer the same way the main Add to basket button does
 * (CartAddEvent with the drawer's section HTML) and opens the drawer.
 */
class NlRelatedProducts extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
    if (this.dataset.url && !this.querySelector('.nl-rel__grid')) this.#load();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  async #load() {
    try {
      const response = await fetch(this.dataset.url);
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fresh = html.querySelector('nl-related-products');
      if (fresh) this.innerHTML = fresh.innerHTML;
    } catch (error) {
      console.error(error);
    }
  }

  #onClick = (event) => {
    const button = event.target.closest('button[data-variant-id]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    this.#add(button);
  };

  async #add(button) {
    const label = button.querySelector('.nl-rel__button-text');
    const original = label.textContent;
    const status = this.querySelector('[data-nl-rel-status]');
    button.setAttribute('aria-busy', 'true');
    label.textContent = 'Adding…';

    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);

    try {
      // Theme.routes.cart_add_url is already the .js endpoint
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
          sections: sectionIds.join(','),
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Could not add to basket');

      const cart = await (await fetch(`${Theme.routes.cart_url}.js`)).json();
      document.dispatchEvent(
        new CartAddEvent(cart, `nl-related-${button.dataset.productId}`, {
          source: 'nl-related-products',
          itemCount: 1,
          productId: button.dataset.productId,
          sections: data.sections,
        })
      );
      document.querySelector('cart-drawer-component')?.open?.();

      label.textContent = 'Added ✓';
      if (status) status.textContent = 'Added to basket';
      setTimeout(() => { label.textContent = original; }, 2000);
    } catch (error) {
      console.error(error);
      label.textContent = 'Try again';
      if (status) status.textContent = error.message;
      setTimeout(() => { label.textContent = original; }, 2500);
    } finally {
      button.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('nl-related-products')) customElements.define('nl-related-products', NlRelatedProducts);
